import {DataRow} from '../../../DoraData/data-row';

export class PreselectElement {
    // tslint:disable-next-line:variable-name
    private _description = '';
    // tslint:disable-next-line:variable-name
    private _img = '';
    // tslint:disable-next-line:variable-name
    private _gridIdRowList = '';
    // tslint:disable-next-line:variable-name
    private _level = 1;
  // tslint:disable-next-line:variable-name
    private _id = '';
  // tslint:disable-next-line:variable-name
    private _children: PreselectElement[] = [];
  // tslint:disable-next-line:variable-name
    private _selected = false;

    constructor(dataRow: DataRow) {
        this._description = dataRow.Description;
        this._level = dataRow.Level;
        this._gridIdRowList = dataRow.GridId;
        this._img = dataRow.getTuplaValue('Img', '');
        this._id = dataRow.Id;
    }

  get id(): string {
    return this._id;
  }

  get description(): string {
        return this._description;
    }

    get img(): string {
        return this._img;
    }

    get gridIdRowList(): string {
        return this._gridIdRowList;
    }

    get level(): number {
        return this._level;
    }

  get selected(): boolean {
    return this._selected;
  }

  set selected(value: boolean) {
    this._selected = value;
  }

  get children(): PreselectElement[] {
    return this._children;
  }

  /**
   * Deselect preselect and children
   */
  public deselect(): void {
    this._selected = false;
    this.children.forEach(x => x.deselect());
  }
  public findElement(id: string): PreselectElement | null {

    if (this.id === id) {
      return this;
    }
    this.children.forEach( x => {
      if (x.findElement(id) !== null) {
        return x;
      }
    });
    return null;
  }
}
